// share function system fallback
// it can be a browser feature flag, so share button (share-area) is always display:none until "shareTest" is allowed
export function share() {
    const shareButtons = document.querySelectorAll<HTMLElement>("[data-share]");

    if (shareButtons.length > 0) {
        shareButtons.forEach((shareButton) => {
            const shareLink = shareButton.dataset.sharelink as string;
            const shareText = shareButton.dataset.sharetext as string;
            const shareTitle = shareButton.dataset.sharetitle as string;
            const shareTest = { title: "Data to share" };

            const shareData: Record<string, unknown> = {
                title: shareTitle,
                text: shareText,
                url: shareLink,
            };

            // in firefox, the function navigator.share is feature flagged
            // MOT82-253
            // @ts-ignore
            if (navigator.share && navigator.canShare(shareTest)) {
                if (shareButton) {
                    if (shareButton.parentElement) {
                        shareButton.parentElement.style.border =
                            "2px solid var(--complex-grey-primary)";
                    }
                    shareButton.style.display = "flex";
                }
            }

            shareButton.addEventListener("click", async (e: MouseEvent) => {
                e.preventDefault();
                try {
                    await navigator.share(shareData);
                    /*console.log('successful');*/
                } catch (err) {
                    /*console.log(`Error: ${err}`);*/
                }
            });
        });
    }
}
